import { create } from "zustand";
const DEFAULT_DURATION = 5000;
let counter = 0;
/**
 * Module-level toast store. Decoupled from React tree so the imperative
 * `toast.*` helpers can fire from anywhere (API callbacks, event handlers)
 * without needing a context. The single <Toaster/> subscribes and renders.
 */
export const useToastStore = create((set, get) => ({
    toasts: [],
    push: (input) => {
        const title = input.title;
        // Дедуп по заголовку среди активных тостов: одно и то же событие часто
        // приходит из двух источников (доменный обработчик страницы + центр
        // уведомлений по WS) — заголовки у них совпадают, а тексты могут слегка
        // отличаться, поэтому ключ дедупа — именно title. Если у входящего есть
        // действие onClose (тост центра «пометить прочитанным»), а у уже
        // показанного — нет, «апгрейдим» существующий на месте: цепляем onClose и
        // перенимаем его тон. Так уцелевший единственный тост всегда несёт крестик-
        // пометку-прочитанным, в каком бы порядке ни пришли источники. Тосты без
        // заголовка (короткие «Скопировано» и т.п.) не дедупятся.
        if (title) {
            const existing = get().toasts.find((t) => t.title === title);
            if (existing) {
                // «Апгрейдим» уже показанный тост действиями центра (крестик-пометка-
                // прочитанным + кнопка «Перейти»), если у него их ещё нет.
                if ((input.onClose && !existing.onClose) || (input.action && !existing.action)) {
                    const nextTone = input.tone ?? existing.tone;
                    set((s) => ({
                        toasts: s.toasts.map((t) => t.id === existing.id
                            ? {
                                ...t,
                                onClose: existing.onClose ?? input.onClose,
                                action: existing.action ?? input.action,
                                tone: nextTone,
                            }
                            : t),
                    }));
                }
                return existing.id;
            }
        }
        counter += 1;
        const id = `toast-${counter}-${Date.now()}`;
        const item = {
            id,
            tone: input.tone ?? "info",
            title: input.title,
            message: input.message,
            duration: input.duration ?? DEFAULT_DURATION,
            onClose: input.onClose,
            action: input.action,
        };
        set((s) => ({ toasts: [...s.toasts, item] }));
        return id;
    },
    dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
    clear: () => set({ toasts: [] }),
}));
